import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

const blockHeight = 600;

export default () => ({
  container: {
    position: 'relative',
    paddingTop: `0 !important`,
    minHeight: blockHeight,
  },

  heroTilesBlock: {
    [media.l.down]: {
      flexDirection: `column`,
    },
  },

  tileBlocks: {
    [media.m.down]: {
      flexDirection: `column`,
    },
  },

  tileCard: {
    flex: `0 0 50%`,
    width: `50%`,
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    minHeight: 250,
    backgroundSize: `cover`,
    backgroundPosition: `center`,

    [media.m.down]: {
      flex: `0 0 100%`,
      width: `100%`,
    },

    '&:after': {
      background: `linear-gradient( 0deg,rgba(255,255,255,0.8) 0%,rgba(255,255,255,0.4) 50%,rgba(255,255,255,0) 70%)`,
      position: `absolute`,
      content: `""`,
      bottom: `0`,
      height: `100%`,
      left: `0`,
      width: `100%`,
    },
  },
  tileImage: {
    height: `100%`,
    width: `100%`,
    objectFit: `cover`,
    position: `absolute`,
  },
  tileContentContainer: {
    width: `100%`,
    display: `flex`,
    flexDirection: `column`,
    zIndex: 1,
    padding: `0 1rem 0.5rem`,
  },
  tileTitle: {
    color: colors.white,
    fontWeight: font.bold,
    fontSize: scale.s,
  },
  tileMetaContainer: {
    display: `flex`,
    width: `100%`,
    justifyContent: `space-between`,
    color: colors.white,
    alignItems: `flex-start`,
    gap: scale.xxs,
    flexDirection: `column`,
  },
  tileMeta: {
    display: `flex`,
    justifyContent: `flex-start`,
    alignItems: `center`,
    color: colors.white,
  },
  authorMeta: {
    '> img': {
      width: 27,
      height: 27,
      borderRadius: `50%`,
      marginRight: `10px`,
    },
  },
  tileAuthor: {
    fontSize: scale.xs,
  },
  tileDate: {
    fontSize: scale.xs,
  },
  tileCategory: {
    backgroundColor: colors.travel360.secondary,
    color: colors.black,
    padding: `1px 1px 1px 7px`,
    fontSize: scale.xs,
    fontWeight: font.bold,
    textTransform: `uppercase`,
    borderRadius: `4px`,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',

    '&:hover': {
      color: colors.black,
      textDecoration: 'none',

      '& > div': {
        textDecoration: 'underline',
      },
    },
  },
  
  tileTitleLink: {
    display: 'block',
    lineHeight: '25px',
    marginBottom: scale.xxs,

    '& > a': {
      lineHeight: scale.m,
    }
  },

  tileLink: {
    color: colors.black,

    '&:hover': {
      color: colors.black,
      textDecoration: 'underline',
    },
  },

  featuredTileTitleLink: {
    lineHeight: scale.m,
    marginBottom: scale.xs,

    [media.m.down]: {
      marginBottom: scale.xxs,
      lineHeight: '25px',
    },
  },

  featuredTileCard: {

    '&:after': {
      background: `linear-gradient( 0deg,rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.4) 70%, rgba(255,255,255,0) 100%)`,
      position: `absolute`,
      content: `""`,
      bottom: `0`,
      height: `40%`,
      left: `0`,
      width: `100%`,

      [media.m.down]: {
        height: '60% !important',
      },
    },

    [media.xl.down]: {
      flex: `0 0 calc(100% / 3) !important`,
      width: `calc(100% / 3) !important`,
    },

    [media.l.down]: {
      flex: `0 0 100% !important`,
      width: `100% !important`,
    },
  },
  featuredTileImage: {},
  featuredTileTitle: {
    fontSize: scale.m,

    [media.m.down]: {
      fontSize: scale.s,
    },
  },
  featuredTileMetaContainer: {
    [media.xl.up]: {
      flexDirection: `row !important`,
    },
  },
  featuredTileAuthorMeta: {},
  featuredTileCategory: {},
});
